import type { SxProps, Theme } from '@mui/material/styles'

export const fluidStyles = `
  height: 100%;
  width: 100%;
`

export const collapsedStyles = `
  display: flex;
  position: absolute;
  bottom: 0.75rem;
  width: 25vw;
  width: 100%;
  height: 50%;
  cursor: default;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  @media (min-width: 768px) {
    top: 1.5rem;
    right: 1.5rem;
    bottom: auto;
    width: 20vw;
    min-width: 150px;
    max-width: 240px;
    max-height: 30vh;
  }
`

export const localOffSx: SxProps<Theme> = {
  position: 'absolute',
  bottom: 0,
  width: '100%',
  height: '50%',
  zIndex: 5,
  overflow: 'hidden',
  borderRadius: { xs: 0, md: '12px' },
  boxShadow: '0 4px 12px rgba(0,0,0,0.25)',
  '@media (min-width: 768px)': {
    top: '1.5rem',
    right: '1.5rem',
    bottom: 'auto',
    width: '20vw',
    minWidth: '150px',
    maxWidth: '240px',
    maxHeight: '30vh',
  },
}

export const gridContainerSx = (splitView: boolean): SxProps<Theme> => ({
  width: '100%',
  height: '100%',
  position: 'relative',
  display: 'flex',
  '& > div': splitView
    ? {
      flex: 1,
      width: '100% !important',
      height: '100% !important',
      display: 'grid !important',
      gridTemplateColumns: '1fr !important',
      gridTemplateRows: '1fr 1fr !important',
      gap: '2px',
    }
    : {
      flex: 1,
      width: '100% !important',
      height: '100% !important',
      minWidth: 0,
      minHeight: 0,
    },
})
